<!--
  Выбор одного снимка с камеры без загрузки на сервер.

  Компонент нужен для сценариев, где пользователь сначала должен увидеть или
  подтвердить снимок, а родительский компонент сам решает, когда его загружать.
  В отличие от AttachmentUploader, PhotoPicker не создаёт attachment, не хранит
  список файлов и не управляет preview.

  По умолчанию компонент запрашивает основную камеру устройства через
  capture="environment". На компьютере, где камера в таком режиме недоступна,
  браузер показывает системный выбор изображения. Выбранный File возвращается
  через событие file-selected.

  Пример:
  <AttachmentPhotoPicker
    label="Сделать фото"
    @file-selected="selectPhoto"
  />
-->
<template>
  <div class="photo-picker">
    <base-primary-button
      v-if="variant === 'primary'"
      type="button"
      :size="size"
      :icon="icon"
      :disabled="disabled"
      @click="openPicker"
    >
      {{ label }}
    </base-primary-button>
    <base-button
      v-else
      type="button"
      :variant="variant"
      :size="size"
      :icon="icon"
      :disabled="disabled"
      @click="openPicker"
    >
      {{ label }}
    </base-button>
    <input
      ref="input"
      :id="inputId || null"
      class="photo-picker__input"
      type="file"
      accept="image/*"
      :capture="capture || null"
      :disabled="disabled"
      @change="selectPhoto"
    />
  </div>
</template>

<script>
export default {
  name: "AttachmentPhotoPicker",
  props: {
    inputId: { type: String, default: "" },
    label: { type: String, default: "Выбрать фото" },
    capture: {
      type: String,
      default: "environment",
      validator: (value) => ["", "user", "environment"].includes(value),
    },
    disabled: { type: Boolean, default: false },
    variant: { type: String, default: "secondary" },
    size: { type: String, default: "normal" },
    icon: { type: String, default: "camera" },
  },
  emits: ["file-selected"],
  methods: {
    openPicker() {
      if (!this.disabled) this.$refs.input.click();
    },
    selectPhoto(event) {
      const file = event.target.files?.[0];
      event.target.value = "";
      if (!file?.type.startsWith("image/")) return;

      this.$emit("file-selected", file);
    },
  },
};
</script>

<style scoped>
.photo-picker,
.photo-picker :deep(.btn) {
  width: 100%;
}

.photo-picker__input {
  display: none;
}
</style>
